var $ = require('jquery');

$(function () {
    $(".contextual-contact__contact-directory__view-more a, .contextual-contact__contact-directory__view-less a").on("click",
        function(e) {
            e.preventDefault();

            var parentDiv = $(this).closest(".row");
            parentDiv.find(".contextual-contact__contact-directory__view-more").toggle();
            parentDiv.find(".contextual-contact__contact-directory__view-less").toggle();
            parentDiv.find(".contextual-contact__contact-directory__view-more-wrapper").toggleClass('view-more-toggled');
        });
});